import { useCallback, useEffect } from 'react';
import { NotificationMessageType } from "../../../utils/configuration";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import notificationService from "../../../services/notification-service";

export const useTransportOrderNotifications = ({
    deviceId,
    setData,
    orderBy,
    order,
    page,
    rowsPerPage,
    searchData,
    getListTransportOrderManagement
}) => {
    const handleTransportOrderAssignDelivery = useCallback((deliveryData) => {
        try {
            if (!deliveryData) return;
            if (deliveryData.deviceId === deviceId) return;

            setData(currentData => {
                const updatedData = [...currentData];
                const transportOrderIndex = updatedData.findIndex(item => item.id == deliveryData.transportOrderId);

                if (transportOrderIndex !== -1) {
                    const updatedTransportOrder = { ...updatedData[transportOrderIndex] };
                    const newDelivery = {
                        deliverDate: deliveryData.deliverDate,
                        description: deliveryData.description,
                        herdsmanDeliverId: deliveryData.herdsmanDeliverId,
                        isActived: deliveryData.isActived,
                        isDelete: deliveryData.isDelete,
                        status: deliveryData.status,
                        createdBy: deliveryData.createdBy,
                        createdDate: deliveryData.createdDate,
                        modifiedBy: deliveryData.modifiedBy,
                        modifiedDate: deliveryData.modifiedDate,
                        transportOrderId: deliveryData.transportOrderId,
                        herdsmanDeliverName: deliveryData.herdsmanDeliverName
                    };

                    if (!updatedTransportOrder.deliveries) {
                        updatedTransportOrder.deliveries = [];
                    }

                    const existingDeliveryIndex = updatedTransportOrder.deliveries.findIndex(
                        d => d.herdsmanDeliverId === deliveryData.herdsmanDeliverId
                    );

                    if (existingDeliveryIndex !== -1) {
                        updatedTransportOrder.deliveries[existingDeliveryIndex] = newDelivery;
                    } else {
                        updatedTransportOrder.deliveries.push(newDelivery);
                    }

                    updatedTransportOrder.statusName = "Đang lấy hàng";
                    updatedTransportOrder.status = 45;

                    updatedData[transportOrderIndex] = updatedTransportOrder;

                    ShowNotification(
                        `Đơn vận chuyển #${deliveryData.transportOrderId} đã được gán cho ${deliveryData.herdsmanDeliverName}`,
                        NotificationMessageType.Success
                    );
                }
                return updatedData;
            });
        } catch (error) {
            console.error('Error in handleTransportOrderAssignDelivery:', error);
        }
    }, [deviceId, setData]);

    const handleTransportOrderGenericNotification = useCallback((data) => {
        const sortExpression = orderBy + ' ' + order + ((orderBy && orderBy !== "receiptTime") ? ', receiptTime asc' : '') + ', commune.District.Name asc, commune.Name asc';
        getListTransportOrderManagement(page, rowsPerPage, sortExpression, searchData);
    }, [page, rowsPerPage, orderBy, order, searchData, getListTransportOrderManagement]);

    const handleTransportOrderClearDelivery = useCallback((clearData) => {
        try {
            if (!clearData) return;
            if (clearData.deviceId === deviceId) return;

            setData(currentData => {
                const updatedData = [...currentData];
                const transportOrderIndex = updatedData.findIndex(item => item.cuisineOrderID == clearData.cuisineOrderId);

                if (transportOrderIndex !== -1) {
                    const updatedTransportOrder = { ...updatedData[transportOrderIndex] };
                    updatedTransportOrder.deliveries = [];
                    updatedTransportOrder.statusName = "Chờ điều giao";
                    updatedTransportOrder.status = 40;

                    updatedData[transportOrderIndex] = updatedTransportOrder;

                    ShowNotification(
                        `Đơn vận chuyển cho đơn suất ăn #${clearData.cuisineOrderId} đã được xóa người giao`,
                        NotificationMessageType.Warning
                    );
                }
                return updatedData;
            });
        } catch (error) {
            console.error('Error in handleTransportOrderClearDelivery:', error);
        }
    }, [deviceId, setData]);

    useEffect(() => {
        let isComponentMounted = true;

        const initSignalR = async () => {
            try {
                await notificationService.initialize();
                if (isComponentMounted) {
                    notificationService.addNotificationListener('transportOrderAssignDelivery', handleTransportOrderAssignDelivery);
                    notificationService.addNotificationListener('transportOrderClearDelivery', handleTransportOrderClearDelivery);
                    notificationService.addNotificationListener('transport_order', handleTransportOrderGenericNotification);
                }
            } catch (error) {
                console.error('Error initializing notification services:', error);
            }
        };

        initSignalR();

        return () => {
            isComponentMounted = false;
            try {
                notificationService.removeNotificationListener('transportOrderAssignDelivery', handleTransportOrderAssignDelivery);
                notificationService.removeNotificationListener('transportOrderClearDelivery', handleTransportOrderClearDelivery);
                notificationService.removeNotificationListener('transport_order', handleTransportOrderGenericNotification);
            } catch (error) {
                console.error('Error removing SignalR listeners:', error);
            }
        };
    }, [handleTransportOrderAssignDelivery, handleTransportOrderClearDelivery, handleTransportOrderGenericNotification]);
};
